
export const reportLmsAction = async (verbId, objectId, duration = null, objectName) => {
  const apiUrl = `${window.config.baseApiUrl}/gamification/api/aimenu/lmsAction`;

  try {
    const payload = JSON.stringify({
      verbId,
      objectId,
      duration,
      objectName
    });

    // if (navigator.sendBeacon) {
    //   const success = navigator.sendBeacon(`${apiUrl}`, payload);
    //   if (!success) {
    //     console.error('Failed to send action using sendBeacon.');
    //   }
    // } else {
    fetch(`${apiUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: payload,
      keepalive: true,
    });

  } catch (error) {
    console.error(`Error reporting ${verbId} action:`, error);
  }
};
